module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    attrs: {
      "id": "heading_id_20"
    }
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', [_vm._v("I am grateful to Clare Heath-Whyte and Matthew Mason for commenting on the manuscript, to Andy Rees and David Heath-Whyte for help with the diagrams, and to Jonty Frith for suggesting the title.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5713f19c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Acknowledgments.vue
// module id = 63
// module chunks = 0